/* eslint-disable no-undef */

const { default: createCssClasses } = require('./css/customCssClasses');
const { logDebugging, logError } = require('./log/logger');
const { default: loadScript } = require('./utils/load_script');
const { default: generateConfigPlayer } = require('./validations/generateConfigPlayer');
// eslint-disable-next-line no-use-before-define
logDebugging('home');

createCssClasses();

function getPlayersDiv() {
  const playersInPage = document.querySelectorAll('.tpx-player-editorial');
  logDebugging('playersInPage', playersInPage);

  return playersInPage;
}

function getIdFromYoutubeUrl(url) {
  const videoId = url.split('v=')[1];
  return videoId;
}

document.addEventListener('DOMContentLoaded', async () => {
  const playersInPage = getPlayersDiv();
  if (playersInPage.length > 0) {
    await loadScript(process.env.HOST_LIBRARY_PLAYER + process.env.IFRAME_LIBRARY);
    playersInPage.forEach((divItem) => {
      let idYoutube = divItem.dataset.idyt;
      if (!idYoutube) {
        const urlYoutube = divItem.dataset.urlyt;
        if (!urlYoutube) {
          logError('urlyt not found');
          return;
        }
        idYoutube = getIdFromYoutubeUrl(urlYoutube);
        if (!idYoutube) {
          logError('idyt not found');
          return;
        }
      }
      const configPlayer = generateConfigPlayer(divItem.id, idYoutube);
      tpxplayer.tpxplayerIframe.init(configPlayer, (event, player) => {
        logDebugging('player loaded ', event, player);
      });
    });
  }
});
